import _ from 'lodash'

export default {
  methods: {
    formHasError() {
      return !_.isEmpty(this.formErrors)
    },
    formElementHasError(element) {
      return !!this.getFormElementError(element)
    },
    getFormElementError(element) {
      return _.head(this.getFormElementErrors(element))
    },
    getFormElementErrors(element) {
      let errors = _.chain(this).get('formErrors').get(element).value()
      if (_.isObject(errors)) {
        return _.chain(errors)
          .map((err) => {
            if (_.isObject(err)) {
              return _.chain(err).flatMapDeep().join().value()
            } else {
              return err
            }
          })
          .values()
          .value()
      } else {
        return errors
      }
    },
    alertUserOfFormError(response) {
      if (!this.isResponseHasFormErrors(response)) {
        return
      }

      let formError = null
      _.forEach(this.getResponseFormErrors(response), (message) => {
        if (formError) {
          return
        }
        formError = `${message}`
      })

      if (!formError) {
        return
      }
      this.$alertify.error(formError)
    },
    isResponseHasFormErrors(response) {
      return !_.isEmpty(this.getResponseFormErrors(response))
    },
    getResponseFormErrors(response) {
      return _.get(response, ['data', 'formErrors'], {})
    }
  }
}
